_tokenCounter